// extracted by mini-css-extract-plugin
export var card = "BrandCard-module--card--baf4f";
export var face = "BrandCard-module--face--1d41f";
export var hasSocial = "BrandCard-module--hasSocial--3ae5a";
export var logo = "BrandCard-module--logo--ae8fd";
export var logoWrapper = "BrandCard-module--logoWrapper--b6d20";
export var socialLinks = "BrandCard-module--socialLinks--17902";